import ko from "knockout";

/**
 * <p>Binding handler for rendering localized date strings. Parameters are:</p>
 * <dl>
 *  <dt>date</dt>
 *  <dd>the date to format in the current locale. Undefined is allowed.</dd>
 *  <dt>format</dt>
 *  <dd>the moment.js format to use. Default is 'LLLL'. More explaination here: {http://momentjs.com/docs/#/displaying/format/}</dd>
 *  <dt>locale</dt>
 *  <dd>the locale to use. Default is current locale</dd>
 *</dl>
 * <pre class="prettyprint">
 * &lt;span data-bind="lDate: {date: new Date(), format: "LLLL"}"&gt;
 * &lt;/span&gt;
 * </pre>
 *
 * @exports extensions/i18n/knockout-lDate
 */
ko.bindingHandlers.lDate = {
    init: function () {},
    update: function (
        element,
        valueAccessor /*, allBindingsAccessor, viewModel*/
    ) {
        let date, format, locale;
        const dateInfo = ko.utils.unwrapObservable(valueAccessor());

        if (dateInfo && dateInfo instanceof Date) {
            date = dateInfo;
            format = "LLLL";
            element.textContent = ko.i18n.formatDate(date, format, locale);
        } else if (dateInfo && dateInfo.date) {
            date = ko.unwrap(dateInfo.date);
            format = dateInfo.format || "LLLL";
            locale = dateInfo.locale;

            if (!/[a-zA-Z]/.test(date) && !/\d/.test(date)) {
                // if we just have a character that we don't want to localize (such as '-')
                element.textContent = date;
            } else {
                element.textContent = ko.i18n.formatDate(date, format, locale);
            }
        }
    },
};

export default ko.bindingHandlers.lDate;
